import { Capacitor } from "@capacitor/core";
import PublicIcon from "@mui/icons-material/Public";
import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import { HiOutlineBars4 } from "react-icons/hi2";
import { Link } from "react-router-dom";
import { menuItems } from "../Strings/Strings";
import { AppContext } from "../context/AppContext";
import Logo from "./ReuseComponent/Navbar/Logo";
import "./css/Navbar.css";

export default function Navbar() {
  const { setMobileNavOpen, mobileNavOpen, isInNetwork } =
    React.useContext(AppContext);

  const handleMobileNavToggle = () => {
    setMobileNavOpen(!mobileNavOpen);
  };

  React.useEffect(() => {
    OptionSelection();
  }, [isInNetwork]);

  const OptionSelection = () => {
    setMobileNavOpen(false);
  };

  return (
    <div>
      <header
        id="header"
        className={`d-flex align-items-center fixed-top`}
        style={{ display: "flex", justifyContent: "center" }}
      >
        <div className="d-flex align-items-center justify-content-between w-100 px-3">
          <Logo OptionSelection={OptionSelection} />
          {/* nav items */}
          {isInNetwork && (
            <nav
              id="navbar"
              className={`navbar order-last order-lg-0 ${
                mobileNavOpen ? "navbar-mobile" : ""
              }`}
            >
              {!Capacitor.isNativePlatform() ? (
                <ul>
                  {menuItems.map((item, index) => (
                    <li
                      key={index}
                      aria-label={`Navigation item for ${item.title}`}
                    >
                      <Link
                        className={`nav-linksignin`}
                        to={item.link}
                        onClick={OptionSelection}
                        aria-label={`Go to ${item.title}`}
                      >
                        {item.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              ) : (
                <ul>
                  <div className="d-flex flex-column gap-3 h-100 ">
                    <Logo OptionSelection={OptionSelection} />
                    <div className="d-flex flex-column justify-content-between h-100">
                      <div>
                        {menuItems.map((item, index) => (
                          <li
                            key={index}
                            className="my-1"
                            aria-label={`Navigation item for ${item.title}`}
                          >
                            <Link
                              className={`nav-linksignin shadow p-4 bg-light-subtle.bg-gradient justify-content-start gap-3`}
                              to={item.link}
                              onClick={OptionSelection}
                              aria-label={`Go to ${item.title}`}
                            >
                              {item.icon} {item.title}
                            </Link>
                          </li>
                        ))}
                      </div>
                      <div className="d-flex justify-content-end px-3">
                        <Link
                          to={process.env.REACT_APP_PUBLIC}
                          className="bg-primary-subtle p-3 rounded-5 text-dark"
                          aria-label={`Go to Public domain`}
                        >
                          <PublicIcon />
                        </Link>
                      </div>
                    </div>
                  </div>
                </ul>
              )}
              <i className="mobile-nav-toggle" onClick={handleMobileNavToggle}>
                {mobileNavOpen ? (
                  <AiOutlineClose color="white" />
                ) : (
                  <HiOutlineBars4 />
                )}
              </i>
            </nav>
          )}
        </div>
      </header>
    </div>
  );
}
